import { render, staticRenderFns } from "./MyWalletOrbitCards.vue?vue&type=template&id=0036f586&scoped=true"
import script from "./MyWalletOrbitCards.vue?vue&type=script&lang=ts"
export * from "./MyWalletOrbitCards.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletOrbitCards.vue?vue&type=style&index=0&id=0036f586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036f586",
  null
  
)

export default component.exports